import '@/assets/styles/tailwind.css'

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import VueMousetrap from 'vue-mousetrap'
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import VueClipboard from 'vue-clipboard2'
 
Vue.use(VueClipboard)

// Sentry.init({
//   dsn: 'https://0e9ed4850ead430583d377031f53025b@sentry.io/1375149',
//   integrations(integrations) {
//     return integrations.filter(integration => integration.name !== 'Breadcrumbs');
//   }
// });
// Sentry.configureScope((scope) => {
//   scope.setTag("app", "web");
// });
if (window.location.hostname === 'localhost') {
  Sentry.init({
    Vue,
    dsn: 'https://0e9ed4850ead430583d377031f53025b@sentry.io/1375149',
    tracingOptions: {
      trackComponents: true,
    },
    integrations(integrations) {
      return integrations.filter(integration => integration.name !== 'Breadcrumbs');
    },
    logErrors: true,
  });
} else {
  Sentry.init({
    Vue,
    dsn: 'https://0e9ed4850ead430583d377031f53025b@sentry.io/1375149',
    tracingOptions: {
      trackComponents: true,
    },
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    logErrors: true,
  });
}


window.Sentry = Sentry

Vue.use(VueMousetrap)

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app');
